import React from "react";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Layout";
import { mainItemsHref } from "../../store/localItems";

const Home = () => {
  return (
    <Layout sidebar>
      <div className="home">
        <h1 className="home__title">Главная страница</h1>
        <div className="home__grid">
          {mainItemsHref.map((item, index) => (
            <NavLink key={index} to={item.href} className="home__card">
              <div className="home__icon">{item.icon}</div>
              <div className="home__label">{item.text}</div>
            </NavLink>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default Home;
